import React from 'react';
import { useTheme } from './theme-provider';

export default function FounderNote() {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  return (
    <section className={`py-16 relative overflow-hidden ${
      isDarkMode ? 'bg-gradient-to-b from-gray-950 to-gray-900' : 'bg-gradient-to-b from-purple-50 to-white'
    }`}>
      {/* Background effects */}
      {isDarkMode ? (
        <>
          <div className="absolute top-0 left-0 w-full h-[400px] bg-gradient-to-b from-purple-900/10 to-transparent opacity-30 blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-900/10 rounded-full opacity-50 blur-3xl"></div>
        </>
      ) : (
        <div className="absolute inset-0 bg-grid-slate-100 opacity-25 [mask-image:linear-gradient(to_bottom,transparent,black,transparent)]"></div>
      )}
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        {/* <div className="text-center mb-10">
          <h2 className={`text-3xl md:text-4xl font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
            Note from the Founder
          </h2>
        </div> */}
        
        <div className="max-w-5xl mx-auto">
          <div className={`relative transform rotate-[-1deg] ${
            isDarkMode ? 'bg-gray-800 shadow-xl shadow-purple-900/20' : 'bg-white shadow-xl'
          } rounded-lg p-8 md:p-10`}>
            {/* Paper texture effect */}
            <div className="absolute inset-0 opacity-5 mix-blend-overlay bg-texture rounded-lg"></div>
            
            {/* Note content */}
            <div className="relative z-10">
              <div className={`font-handwriting leading-relaxed ${
                isDarkMode ? 'text-gray-100' : 'text-gray-800'
              }`}>
                <div className="flex items-center gap-3 mb-0">
                  <div className="w-16 h-16 rounded-full overflow-hidden ring-2 ring-purple-300 ring-opacity-50 flex-shrink-0 shadow-lg transform hover:scale-105 transition-transform duration-300">
                    {/* <img 
                      src="/images/founder-image.png" 
                      alt="Asif Farhan Khan" 
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        // If image fails to load, hide the entire circular div
                        e.target.parentElement.style.display = 'none';
                      }}
                    /> */}
                  </div>
                  <h1 className="font-bold text-4xl italic">Note from the Founder</h1>
                </div>
                
                <p className="mb-8 text-center font-bold border-b pb-4 text-3xl md:text-5xl bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-transparent bg-clip-text">
                  We are growing with your brand!
                </p>
                
                <p className="mb-7 text-2xl md:text-[27px]">
                  At SmushLabs, our aim is to understand each customer's business knowledge and build practical tools that solve specific problems. We do not assume one configuration will suit every company.
                <br/><br/>
                
                  This vision is driving our roadmap to create an autopilot support ecosystem that will be both effortless and cost-effective. We're designing it to integrate seamlessly with your existing CRMs, analytics platforms, and business tools - enhancing your operations without disrupting established workflows.
                  <br/><br/>
                
                  To fulfill this mission, we're developing SmushChat as the cornerstone of this ecosystem. Through planned future developments, this innovation will empower your team to focus on what truly matters: growing your business and delighting your customers, while we handle the heavy lifting of customer support. We invite you to join us from the start of this journey - together, we'll shape the future of customer support.
                </p>
                
                <div className="mt-10 flex justify-end">
                  <div className="flex flex-col items-end">
                    <img 
                      src="/images/signature.png" 
                      alt="Asif Farhan Khan's signature" 
                      className="h-12 mb-2"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        document.getElementById('text-signature').style.display = 'block';
                      }}
                    />
                    <div id="text-signature" className="font-signature text-2xl mb-1 hidden">Asif Farhan Khan</div>
                    <p className="text-lg font-medium" style={{color: isDarkMode ? "#D1D5DB" : "#4B5563"}}>Founder - SmushLabs</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute top-5 left-5 w-10 h-10 rounded-full border-4 border-yellow-300 opacity-70"></div>
            <div className="absolute bottom-5 right-8 w-8 h-8 rounded-full border-4 border-purple-300 opacity-70"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
